module.exports = "https://cdn.realtymogul.com/static/media/hero.be8fd0cb.jpg";